import { getSecureOAuthToken } from './tokenManager';
import constants from '../config/index.json';
import store from '../redux/store';
import { CREATE_NEW_USER } from '../constants/common.const';

const HEADERS = {
    authorization: 'Authorization',
    accountSharedId: 'X-Ep-Account-Shared-Id',
    userTraits: 'X-Ep-User-Traits',
    sessionAttributes: 'X-Session-Attributes',
    contentType: 'Content-Type',
    accept: 'Accept',
    xForwardedBase: 'X-Forwarded-Base',
    userScopes: 'X-Ep-User-Scopes',
};

const parseHeader = requiredHeaders => {
    const parsedHeaders = {};
    const locale = localStorage.getItem('preferredLocale') ? localStorage.getItem('preferredLocale') : '';
    const currency = localStorage.getItem('customerDefaultCurrency') ? localStorage.getItem('customerDefaultCurrency') : '';
    const headerMapping = {
        authorization: getSecureOAuthToken(),
        accountSharedId: localStorage.getItem('defaultUserID'),
        sessionAttributes: `CURRENCY=${currency},LOCALE=${locale}`,
        userTraits: '',
        contentType: '',
        accept: '',
        xForwardedBase: '',
        userScopes: '',
    };
    Object.keys(requiredHeaders).forEach(key => {
        const value = requiredHeaders[key] === '' ? '' : requiredHeaders[key];
        parsedHeaders[HEADERS[key]] = value === '' ? headerMapping[key] : value;
    });

    return parsedHeaders;
};

const getHeader = ({ functionName, values = [] }) => {
    const headersConfig = {
        'common.getSplashMessage': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'common.setNotNowSplashMessage': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'common.getEPEnabledAccounts': { authorization: '', sessionAttributes: '' },
        'common.getContactDetails': { authorization: '', sessionAttributes: '' },

        'login.generateAxiosInstance1': { authorization: '', contentType: values[0], sessionAttributes: '' },
        'login.getDynamicMenu': { authorization: '', accountSharedId: values[0], sessionAttributes: '' },
        'login.getTokenRemove': { authorization: '', sessionAttributes: '' },
        'login.logoutFromOkta': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'login.generateAxiosInstance': { authorization: values[0], contentType: values[1] },
        'login.getStoreName': { accept: values[0], xForwardedBase: values[1] },
        'login.getUserIdFromOkta': { accept: values[0] },
        'login.defaultprofile': { authorization: '', contentType: values[0], sessionAttributes: '' },
        'login.defaultprofileWithAccount': { authorization: '', accountSharedId: '', contentType: values[0], sessionAttributes: '' },
        'login.myCompanyPermission': { authorization: '', accountSharedId: '', contentType: values[0], sessionAttributes: '' },
        'login.sleepLabPermission': { authorization: '', contentType: values[0], sessionAttributes: '' },
        'login.dealerLocatorPermission': { authorization: '', contentType: values[0], sessionAttributes: '' },
        'login.getRequestTypes': { authorization: '', contentType: values[0], sessionAttributes: '' },
        'login.getUserList': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'login.getFilteredUsers': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'login.getAssociatedCompanyName': { authorization: values[0], sessionAttributes: '' },
        'login.getorgId': { authorization: values[0], sessionAttributes: '' },
        'login.getRequestTypesBeforeLogin': { authorization: values[0], sessionAttributes: '' },
        'login.createNewUserBeforLogin': { authorization: values[0], sessionAttributes: '' },

        'userDetails.getUserAccountDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'userDetails.updateUserAccountDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'userDetails.getSecurityQuestions': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'userDetails.updatePassword': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'userDetails.getAllCountryNames': { authorization: '', sessionAttributes: '' },
        'userDetails.resetPassword': { authorization: values[0], sessionAttributes: '' },
        'userDetails.getUserResetPassword': { authorization: values[0], sessionAttributes: '' },
        'userDetails.verifyEmail': { authorization: values[0], sessionAttributes: '' },

        'getMyAddressAccess.getMyAddressAccess': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'manageAddress.getCountries': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.addNewAddressMyAccount': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.updateAddressMyAccount': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.updateWebsiteAddress': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.getAllAddresses': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.getSingleAddresses': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.getDuplicateAddress': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageAddress.updateBedCount': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        [CREATE_NEW_USER]: { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageUser.updateUser': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageUser.resetUserPassword': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageUser.changeUserAccountStatus': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'manageUser.checkOrderReview': { authorization: '', sessionAttributes: '' },

        'cto.getCTOCustomerList': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'cto.getCtoItems': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'cto.setdefaultShipping': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'cto.setdefaultBilling': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'cto.getShippingMethods': { authorization: '', userTraits: values[0], sessionAttributes: '' },

        'getCrossSell.getCrossSell': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getCrossSell.getNextCrossSell': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getCrossSell.getPreviousCrossSell': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },


        'getDefaultCart.getDefaultCartID': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getDefaultCart.getDefaultCartData': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getDefaultCart.calculateTax': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getDefaultCart.emptyCart': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getDefaultCart.getOrderConfirmationDetails': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'getDefaultCart.getQuotePdfDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },


        'paymentMethod.getAuthNetKeys': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'paymentMethod.callEndpoint': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'paymentMethod.highRadiusCall': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'paymentMethod.getBilltoStates': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'globalSearch.itemLookupGS': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'importOrder.importOrderUpload': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'importOrder.importOrderBulkLookUp': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'itemLookup.itemLookup': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'itemLookup.getRecommendations': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'productCatelog.getOrderType': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'productCatelog.getDefaultOrderType': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'productCatelog.getNavProductList': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'productCatelog.getNavProductListExtra': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'productCatelog.getNavProductListWithPagination': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'productPreview.selectVarient': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'productPreview.getMarketingDownload': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'promoCode.addPromoCode': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'promoCode.checkoutRSVPLimits': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'promoCode.getFreightCharges': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'promoCode.getRefreshCheckout': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'promoCode.getInvoiceDueCheckout': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'quickEntry.quickEntryAddToCart': { authorization: '', accountSharedId: values[0], userTraits: values[1], sessionAttributes: '' },
        'quickEntry.searchItem': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'quickEntry.itemLookupQE': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'saveCart.createSavedCart': { authorization: '', accountSharedId: values[0], userTraits: values[1], sessionAttributes: '' },
        'saveCart.deleteSavedCart': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'saveCart.listAllSaveCart': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'saveCart.movedSavedCart': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'addToCart.callWithDynamicEndpoint': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'addToCart.getRequestWithDynamicEndpoint': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'addToCart.checkAddtoCartMessage': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'addToCart.checkShippingRestrictions': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'addToCart.shippingMethodEnabled': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'addToCart.taxColumnEnabled': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'addToCart.checkoutCommonUtils': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'addToCart.purchaseReferenceNumberEnabled': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'adverseEvent.saveAdverseEvents': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'payments.postClientSecret': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'payments.getSurCharges': { authorization: '', sessionAttributes: '' },
        'payments.getClientSecretUrl': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'payments.postPaymentMethod': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'payments.getFeesFinalAmount': { authorization: '', sessionAttributes: '' },
        'payments.getPaymentMethodUrl': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'dvaCreditClaims.saveDVAtoDraft': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaims.getDvaEligibilityStatus': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },
        'dvaCreditClaims.getDraftsHistory': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaims.getNextPage': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaims.getCompleteForm': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },
        'dvaCreditClaims.deleteDraft': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaims.getStateValues': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaim.getDvaManualFormLinks': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'dvaCreditClaim.getDVAItemDetails': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },
        'dvaCreditClaim.itemBulkValidation': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },

        'maskGuarantee.getShippingDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'maskGuarantee.getCompValidation': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'maskGuarantee.callSetdefaultShippingMg': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'maskGuarantee.getMGHistoryRecords': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'maskGuarantee.setAcceptTearms': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'maskGuarantee.itemLookup': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'maskGuarantee.checkMagneticMask': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'ReasonCodes.getReasonCodes': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'removeItem.removeItemFromTheCart': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'returnHistory.getReturnHistoryRecords': { authorization: '', accountSharedId: values[0], sessionAttributes: '' },
        'returnHistory.getOrderDetails': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },
        'returnHistory.submitQuote': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'returnHistory.getShipmentDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'returnHistory.getContainerDetails': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'returnHistory.getInvoiceDetails': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0] },
        'returnHistory.getSrRepairStatus': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'returnHistory.sendLongFormNotification': { authorization: '', accountSharedId: '', sessionAttributes: '', userTraits: values[0]},
        'returnHistory.getSrStatusOptions': { authorization: '', accountSharedId: '', sessionAttributes: '' },

        'searchProduct.getProductList': { authorization: '', accountSharedId: values[0], userTraits: values[1], sessionAttributes: '' },
        'searchProduct.getAssociatedCompanyName': { authorization: '', accountSharedId: values[0], sessionAttributes: '' },

        'shippingInformation.getBillingAddress': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getShippingAddress': { authorization: '', accountSharedId: values[0], userScopes: values[1], userTraits: values[2], sessionAttributes: '' },
        'shippingInformation.getContactAddress': { authorization: '', accountSharedId: values[0], userScopes: values[1], userTraits: values[2], sessionAttributes: '' },
        'shippingInformation.callSetdefaultShipping': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.submitDropShip': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.callSetdefaultBilling': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.setDefaultcontactInfo': { authorization: '', accountSharedId: '', sessionAttributes: '' },
        'shippingInformation.getOrderId': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getShippingMethod': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getShippingNewMethod': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.callSetDefaultShippingMethod': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.setDefaultShippingForAccount': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getDefaultShippingForAccount': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getReturnCenterAddress': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'shippingInformation.getShippingInfoNote': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'summary.getSummary': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
        'summary.getSummaryReturnHome': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },

        'uploadFile.getPresignedURL': { authorization: '', accountSharedId: '', contentType: values[0], sessionAttributes: '' },

        'warrantyCheck.checkWarranty': { authorization: '', accountSharedId: '', userTraits: values[0], sessionAttributes: '' },
    };

    if (typeof functionName === 'string') {
      const orgID = store.getState()?.authentication?.user?.CP_ORGID ?? '';
      const locale = localStorage.getItem('preferredLocale') || '';

      const isInvalid = (val) =>
        val == null || val === '' || val === 'undefined' || val === 'null';

      if (functionName.startsWith('payments') && orgID === constants.orgId.APAC) {
          const paymentCurrency =
            localStorage.getItem('customerAPCurrency') ||
            localStorage.getItem('customerDefaultCurrency');
          if (
            headersConfig[functionName] &&
            !headersConfig[functionName].sessionAttributes
          ) {
            headersConfig[
              functionName
            ].sessionAttributes = `CURRENCY=${paymentCurrency},LOCALE=${locale}`;
        }
      } else {
        const { cartDetails } = store?.getState() || {};
        const lsCurrency = localStorage.getItem('customerDefaultCurrency');
        const reduxCurrency = cartDetails?.currency;

        if (isInvalid(lsCurrency) && !isInvalid(reduxCurrency)) {
          headersConfig[
            functionName
          ].sessionAttributes = `CURRENCY=${reduxCurrency},LOCALE=${locale}`;
        }
      }
    }
      return parseHeader(headersConfig[functionName]);
};



export default getHeader;



